// React import
import * as React from 'react';
// Standard layout imports
import { Columns, Column } from 'src/components/Layout/Grid';
import Title from 'src/components/Title';
import Box from 'src/components/Box';
import MyPageUserInterests from './myPageUserInterests.component';
import Wrapper from 'src/components/Wrapper';
import Breadcrumb from 'src/components/Breadcrumb';
import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem';
import { Link, withRouter, Redirect } from 'react-router-dom';
import MyPageUserFavorites from './myPageUserFavorites.component';
import MyPageComingCourses from './myPageComingCourses.component';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import { IUserColumns, IComingCourses } from 'src/Entities/User/User';
import { UserSelector } from 'src/Entities/User/User.Selector';
import { IActivityThemeModel } from 'src/Entities/ActivityTheme/ActivityTheme';
import { IActivityCategoryModel } from 'src/Entities/ActivityCategory/ActivityCategory';
import { IActivityModel } from 'src/Entities/Activity/Activity';
import { ActivityThemeSelector } from 'src/Entities/ActivityTheme/ActivityTheme.Selector';
import { ActivityCategorySelector } from 'src/Entities/ActivityCategory/ActivityCategory.Selector';
import {
  webSetUserTopics,
  webRemoveUserFavoriteAction
} from 'src/Entities/User/User.Actions';
import { setSlecetedActivtyAction } from 'src/Entities/PortalState/PortalState.Actions';

interface IMyPageProps {
  user: IUserColumns;
  userInterests: string[];
  themes: IActivityThemeModel[];
  categories: IActivityCategoryModel[];
  userFavoriteActivities: IActivityModel[];
  userComingActivities: IComingCourses[];
  saveUserTopics: (categoryIds: string[]) => void;
  removeFromFavorite: (detailkursusId: number) => void;
  setSelectedActivity: (detailkursusId: number) => void;
}
interface IMyPageState {
  shouldRedirect: boolean;
}

class MyPage extends React.Component<IMyPageProps, IMyPageState> {
  /**
   *
   */
  constructor(props: any) {
    super(props);
    this.state = { shouldRedirect: false };
    this.onTopicSave = this.onTopicSave.bind(this);
    this.onFavoriteRemove = this.onFavoriteRemove.bind(this);
    this.goToActivity = this.goToActivity.bind(this);
  }
  public onTopicSave(categoryIds: string[]) {
    this.props.saveUserTopics(categoryIds);
  }
  public onFavoriteRemove(detailkursusId: number) {
    this.props.removeFromFavorite(detailkursusId);
  }
  public goToActivity(detailkursusId: number) {
    this.props.setSelectedActivity(detailkursusId);
    this.setState(Object.assign(this.state, { shouldRedirect: true }));
  }

  public render() {
    const element = (
      <div className="has-background-gray-body">
        <Wrapper>
          <Breadcrumb className="py3">
            <BreadcrumbItem>
              <Link to="">FORSIDE</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active={true}>
              <Link to="">MIN SIDE</Link>{' '}
            </BreadcrumbItem>
          </Breadcrumb>

          <Columns gutter="large">
            <Column md={8}>
              <div className="mb3">
                <Columns>
                  <Column md={10}>
                    <Title>MINE INTERESSER OG KURSUSOMRÅDER</Title>
                  </Column>
                  {/* <Column md={2}><MyPageShowInterestsComponent label={"Aktiveret"} /></Column> */}
                </Columns>
              </div>
              <Box className="mb1">
                Herunder kan du markere de emner, der interesserer dig. <br />
                I søgebilledet kan du vælge "Søg i relevante kurser", så får du
                kun vist kurser inden for disse emner. Du kan altid ændre
                markeringerne. <br />
                <b>Husk altid at gemme!!</b>
              </Box>
              <div className="mb3">
                <MyPageUserInterests
                  userInterests={this.props.userInterests}
                  categories={this.props.categories}
                  themes={this.props.themes}
                  onTopicSave={this.onTopicSave}
                  didSave={this.props.user.topicsDidSave}
                />
              </div>
              <div className="mb3">
                <MyPageUserFavorites
                  removeFormFavorite={this.onFavoriteRemove}
                  favs={this.props.userFavoriteActivities}
                  setSelectedActivity={this.goToActivity}
                />
              </div>
            </Column>
            <Column md={4}>
              {
                <div className="mb4">
                  <Title className="mb3">Mine kommende kurser</Title>
                  <MyPageComingCourses
                    comingActivities={this.props.userComingActivities}
                    showSmallComponent={false}
                    setSelectedActivity={this.goToActivity}
                  />
                </div>
              }
              {/* <div className="mb2">
                <MyPageCourseEvaluations /> 
            </div> */}
            </Column>
          </Columns>
        </Wrapper>
        {this.state.shouldRedirect ? (
          <Redirect to="/kursus" push={true} />
        ) : null}
      </div>
    );
    return (
      <div>
        {this.props.themes && this.props.user.portalDetails ? (
          element
        ) : (
          <div>Loading</div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state: any, ownProps: any) {
  return {
    user: UserSelector.getUser(),
    userFavoriteActivities: UserSelector.getUserFavoriteActivities(),
    userComingActivities: UserSelector.getUserComingCourses(),
    themes: ActivityThemeSelector.getThemes(),
    categories: ActivityCategorySelector.getCategories(),
    userInterests: UserSelector.getUserInterests()
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>, ownProps: any) {
  return {
    saveUserTopics: (categoryIds: string[]) =>
      dispatch(webSetUserTopics(categoryIds)),
    removeFromFavorite: (detailkursusId: number) =>
      dispatch(webRemoveUserFavoriteAction(detailkursusId)),
    setSelectedActivity: (detailkursusId: number) =>
      dispatch(setSlecetedActivtyAction(detailkursusId.toString()))
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyPage));



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/MyPage/index.tsx